export const SPAS_INFO_LOADING = 'SPAS_INFO_LOADING' as const;
export const SPAS_INFO_LOADED = 'SPAS_INFO_LOADED' as const;
export const SPAS_INFO_LOAD_ERROR = 'SPAS_INFO_LOAD_ERROR' as const;
export const SPAS_SERVICE_REQUEST_LOADING = 'SPAS_SERVICE_REQUEST_LOADING' as const;
export const SPAS_SERVICE_REQUEST_LOADED = 'SPAS_SERVICE_REQUEST_LOADED' as const;
export const SPAS_SERVICE_REQUEST_LOAD_ERROR = 'SPAS_SERVICE_REQUEST_LOAD_ERROR' as const;
